import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Configuration des routes à précharger
const prefetchConfig = {
    '/': ['/actualites', '/services'],
    '/actualites': ['/incidents', '/services'],
    '/incidents': ['/actualites', '/contact'],
    '/services': ['/contact', '/packpro'],
    '/contact': ['/services'],
    '/packpro': ['/services', '/contact'],
};

// Fonction pour précharger un module
const prefetchModule = (path: string) => {
    switch (path) {
        case '/':
            import('../pages/Home');
            break;
        case '/actualites':
            import('../pages/Actualites');
            break;
        case '/incidents':
            import('../pages/Incidents');
            break;
        case '/services':
            import('../pages/Services');
            break;
        case '/contact':
            import('../pages/Contact');
            break;
        case '/packpro':
            import('../pages/ProfessionalForm');
            break;
        default:
            break;
    }
};

// Hook personnalisé pour le préchargement intelligent
export const usePrefetch = () => {
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        const routesToPrefetch = prefetchConfig[currentPath as keyof typeof prefetchConfig] || [];

        // Précharger après un court délai pour ne pas bloquer le rendu initial
        const timer = setTimeout(() => {
            routesToPrefetch.forEach(route => {
                prefetchModule(route);
            });
        }, 2000);

        return () => clearTimeout(timer);
    }, [location]);
};
